import { Router } from '@reach/router';
import { BetterRedirect } from 'components/app/routing/BetterRedirect';
import { DEFAULT, RouteSpec } from 'components/app/routing/types';
import React, { Component, ReactElement } from 'react';

interface Props {
    routes: RouteSpec;
}

/**
 * Generate Reach Router elements from a RouteSpec
 */
export class Routes extends Component<Props> {
    public render() {
        const routes = this.generateRoutes(this.props.routes);
        return <Router>{...routes}</Router>;
    }

    // Recursively generate Reach Router nodes for the app's paths
    private generateRoutes(routeMap: RouteSpec): Array<ReactElement> {
        return Object.entries(routeMap).map(([path, route]) => {
            const pathProps = path === DEFAULT ? { default: true } : { path };

            if ('component' in route) {
                const { component, children } = route;

                const childRoutes = (children) ? this.generateRoutes(children) : undefined;

                return React.createElement(component, { key: path, ...pathProps }, childRoutes);
            } else {
                const { redirectTo } = route;
                return React.createElement(BetterRedirect, { key: path, to: redirectTo, ...pathProps });
            }
        });
    }
}
